/**
 * 单指标卡片
 */

import React, { ReactNode } from 'react';
import { Justify } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import DateCompareBigNumbers from '@customComp/BigNumberChart/DateCompareBigNumbers';
import SingleBigNumber from '@customComp/BigNumberChart/SingleBigNumber';
import UserFilterBigNumbers from '@customComp/BigNumberChart/UserFilterBigNumbers';
import LabelText from "@/pages/datalab/components/LabelText";

export const BIG_NUMBER_CARD_TYPE = {
  userFilter: UserFilterBigNumbers,
  dateCompare: DateCompareBigNumbers,
  singleBigNumber: SingleBigNumber,
} as const;

export type TBigNumberCardType = keyof typeof BIG_NUMBER_CARD_TYPE;

type TBigNumberChartComponentPropsMap = {
  userFilter: React.ComponentProps<typeof UserFilterBigNumbers>;
  dateCompare: React.ComponentProps<typeof DateCompareBigNumbers>;
  singleBigNumber: React.ComponentProps<typeof SingleBigNumber>;
};

export interface IBigNumberChartProps<
  T extends TBigNumberCardType = TBigNumberCardType,
> {
  className?: string;
  right?: ReactNode;
  subTitle?: ReactNode;
  type: T;
  componentProps: TBigNumberChartComponentPropsMap[T];
  title?: ReactNode;
  icon: string;
}

const BigNumberChart: React.FC<IBigNumberChartProps> = ({
  subTitle,
  type,
  componentProps,
  title,
  icon,
  className = '',
  right,
}) => {
  const Component = BIG_NUMBER_CARD_TYPE[type || 'singleBigNumber'];

  return (
    <div className={`dbl-big-number-wrap ${className}`}>
      <Justify
        className="dbl-big-number-title"
        left={
          <>
            <SvgIcon type={icon} />
            {title}
          </>
        }
        right={right}
      />
      {subTitle ? (
        <LabelText preset={'838697-12-400'} className="dbl-big-number-subTitle">{subTitle}</LabelText>
      ) : null}
      <Component {...componentProps} />
    </div>
  );
};

export default BigNumberChart;